import SquigglyLine2Icon from '@/assets/icons/squiggly-lines/squiggly-line-2.svg?react';
import SquigglyLine9Icon from '@/assets/icons/squiggly-lines/squiggly-line-9.svg?react';
import handPhoneAdjustImg from '@/assets/images/home/hand-phone-adjust.png';
import handPhoneQuizImg from '@/assets/images/home/hand-phone-quiz.png';
import mailBoxImg from '@/assets/images/home/mail-box.png';
import noteBoxImg from '@/assets/images/home/note-box.png';
import { Heading } from '@/components/common/Heading';
import { Section } from '@/components/common/Section';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';

const startingSteps = [
  {
    imgSrc: handPhoneQuizImg,
    title: '1. Quick wellness quiz',
    description: 'Share your lifestyle, goals & concerns.',
  },
  {
    imgSrc: noteBoxImg,
    title: '2. Get recommendations',
    description: 'Based on your needs and your current habits.',
  },
  {
    imgSrc: mailBoxImg,
    title: '3. Delivery to your door',
    description: 'Monthly shipments with no hassle.',
  },
  {
    imgSrc: handPhoneAdjustImg,
    title: '4. Adjust anytime',
    description: 'Your plan grows with you.',
  },
];

export function StartingStepsSection() {
  const { isDesktop } = useBreakpoint();

  return (
    <Section>
      <Heading
        as="h2"
        className="mb-2.5 lg:mb-14"
        underlinedText="4 easy"
        underline={
          isDesktop ? (
            <SquigglyLine9Icon className="-bottom-4 -left-2" />
          ) : (
            <SquigglyLine2Icon className="-bottom-1" />
          )
        }
      >
        Start in 4 easy steps
      </Heading>

      <div className="flex flex-col items-center gap-4 lg:grid lg:grid-cols-4 lg:items-start lg:gap-8.5">
        {startingSteps.map(({ imgSrc, title, description }) => (
          <div
            key={title}
            className="flex max-w-70 flex-col items-center text-center"
          >
            <img
              className="mb-6 w-full max-w-50 lg:mb-6.25 lg:max-w-65"
              src={imgSrc}
              alt={title}
            />

            <Heading as="h3" size={isDesktop ? 'h4' : 'h3'} className="mb-2.5">
              {title}
            </Heading>

            <p className="text-muted-foreground">{description}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}
